import { z } from 'zod';

// Graf prepojení osôb↔firiem (Blok 1, Týždeň 5). Uzol je buď firma alebo osoba, hrana
// je konkrétna rola (štatutár/organ/UBO) v danom časovom okne.
export const graphNodeSchema = z.object({
  id: z.string(), // `company:<uuid>` alebo `person:<uuid>`
  type: z.enum(['company', 'person']),
  label: z.string(),
  ico: z.string().optional(),
  // Len pre type: 'person'. RPO štatutári/orgány neposkytujú dátum narodenia (na
  // rozdiel od RPVS UBO) — bez neho je dedup kľúč osoby len normalizované meno
  // (persons/fingerprint.ts), takže rovnomenné, ale v skutočnosti odlišné osoby sa
  // môžu zlúčiť do jedného uzla a vytvoriť falošné prepojenie medzi firmami. `false`
  // znamená "táto identita je len zhoda mena, nepotvrdená dátumom narodenia".
  identityConfirmed: z.boolean().optional(),
});
export type GraphNode = z.infer<typeof graphNodeSchema>;

export const graphEdgeSchema = z.object({
  from: z.string(),
  to: z.string(),
  roleLabel: z.string(),
  roleCategory: z.string(),
  validFrom: z.string().nullable(),
  validTo: z.string().nullable(),
  source: z.string(),
});
export type GraphEdge = z.infer<typeof graphEdgeSchema>;

export const networkGraphSchema = z.object({
  nodes: z.array(graphNodeSchema),
  edges: z.array(graphEdgeSchema),
});
export type NetworkGraph = z.infer<typeof networkGraphSchema>;
